import { Box, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { RightArrowIcon } from '@/assets/svg';
import { Button } from '@/components';
import { ROUTE } from '@/router/routes';
import { t } from '@/services/translations/config';
import { COLOR } from '@/theme/colors';

import { Props } from './types';

const SwitchTeam: React.FC<Props> = ({ onClose }) => {
    const navigate = useNavigate();

    return (
        <Box className="flex flex-col justify-center items-center h-full max-w-[300px] mx-auto gap-3">
            <Box className="flex flex-col border-black border rounded-full py-0.5 px-5">
                <Box className="-mb-4 relative left-1.5">
                    <RightArrowIcon />
                </Box>
                <Box className="rotate-180 relative -left-1.5">
                    <RightArrowIcon />
                </Box>
            </Box>
            <Typography
                sx={{ color: COLOR.vividBlack }}
                fontSize={18}
                fontWeight={800}
            >
                {t('PremiumMenuDisabledModal:title')}
            </Typography>
            <Typography
                sx={{ color: COLOR.vividBlack, textAlign: 'center' }}
                fontSize={12}
            >
                {t('PremiumMenuDisabledModal:message_teams')}
            </Typography>

            <Box sx={{ display: 'flex', gap: 2 }}>
                {onClose && (
                    <Button
                        sx={{
                            borderColor: COLOR.lightGray,
                            mt: '12px',
                            color: COLOR.vividBlack,
                        }}
                        caption={t('Actions:cancel')}
                        variant="outlined"
                        onClick={onClose}
                    />
                )}

                <Button
                    sx={{
                        borderColor: COLOR.lightGray,
                        mt: '12px',
                        color: COLOR.vividBlack,
                    }}
                    caption={t('Actions:switch')}
                    variant="outlined"
                    onClick={() => navigate(ROUTE.teams)}
                />
            </Box>
        </Box>
    );
};

export default SwitchTeam;
